module.exports = __webpack_public_path__ + "static/media/illustration-section-08.d5df6cae.svg";